/*
 * Copyright (c) 2017.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 11-9-2017
 * Time: 20:21
 *
 */

angular.module('sihw.datepicker', ['ui.bootstrap', 'sihw.sihwlog', 'sihw.angular.config'])
    .run(['$templateCache', 'sihwDatepickerTemplates', function ($templateCache, sihwDatepickerTemplates) {
        //templates
        $templateCache.put('sihwDatepickerTemplate.html', sihwDatepickerTemplates.main);
        $templateCache.put('sihwDatepickerPopuptemplate.html', sihwDatepickerTemplates.popup);
    }])
    .directive('datepicker', ['sihwAngularConfig', 'sihwlog',
        function (sihwAngularConfig, sihwlog) {
            let log = sihwlog.logLevel(sihwAngularConfig.loglevel('datepicker'));

            let vergelijkers = ['voor', 'voorOfGelijk', 'na', 'naOfGelijk'];
            return {
                restrict: "E",
                scope: {
                    opties: '=?',
                    voor: '=?',
                    voorOfGelijk: '=?',
                    na: '=?',
                    naOfGelijk: '=?',
                    koppel: '=?',
                    //teskten e.d.
                    dateFormat: '<?',
                    currentText: '<?',
                    clearText: '<?',
                    closeText: '<?',
                    //
                    stringdate: '<?' //alleen zodat phpstorm het attribute pikt, we gebruiken attrs
                },
                require: '?ngModel',
                templateUrl: 'sihwDatepickerTemplate.html',
                link: function ($scope, el, attrs, ngModel) {
                    $scope.isopen = false;
                    $scope.lokaleOpties = {};

                    $scope.attrs = attrs;

                    //fix wat opties die we tegenkomen
                    $scope.$watch('opties', function (newvalue) {
                        if (!newvalue) {
                            return;
                        }
                        $scope.lokaleOpties = angular.copy(newvalue);
                        if (moment.isMoment(newvalue.minDate)) {
                            $scope.lokaleOpties._minMoment = newvalue.minDate.clone();
                            $scope.lokaleOpties.minDate = newvalue.minDate.toDate();
                            $scope.lokaleOpties._origMinMoment = $scope.lokaleOpties._minMoment.clone(); //voor als we het beperkten via vergelijkers
                        }
                        else {
                            delete $scope.lokaleOpties._minMoment;
                            delete $scope.lokaleOpties.minDate;
                            delete $scope.lokaleOpties._origMinMoment;
                        }
                        if (moment.isMoment(newvalue.maxDate)) {
                            $scope.lokaleOpties._maxMoment = newvalue.maxDate.clone();
                            $scope.lokaleOpties.maxDate = newvalue.maxDate.toDate();
                            $scope.lokaleOpties._origMaxMoment = $scope.lokaleOpties._maxMoment.clone(); //voor als we het beperken via vergelijkers
                        }
                        else {
                            delete $scope.lokaleOpties._maxMoment;
                            delete $scope.lokaleOpties.maxDate;
                            delete $scope.lokaleOpties._origMaxMoment;
                        }
                        //en check de vergelijkers opnieuw
                        checkVergelijkers();
                        ngModel.$validate(); //opnieuw valideren

                    }, true);

                    //watch de waarde van de vergelijkers. Dat hoeft niet binnen objects
                    $scope.$watchGroup(vergelijkers, checkVergelijkers);

                    //sihw-angular-opties
                    $scope.$sihwng = sihwAngularConfig.opties('datepicker');

                    //map de modelwaarde in ons template op de ngModel van het directive

                    //het model van de directive is gewijzigd, dus zetten we de waarde ook
                    //in onze control (via ons model)
                    ngModel.$render = function () {
                        //viewValue is een string die moment kan parsen, of een moment (of null)
                        $scope.model = ngModel.$viewValue ? moment(ngModel.$viewValue).toDate() : null;
                        checkVergelijkers();
                    };

                    $scope.touched = function () {
                        ngModel.$setTouched(); //we zijn aangeraakt
                    };

                    $scope.openPopup = function () {
                        //we focussen het inputveld, want dan ook een blur straks
                        $(el).find('.sihwdatepickerinputveld').focus(); //even focussen, zodat er zo een blur komt
                        $scope.isopen = true;
                    };

                    /**
                     * Via de ui gewijzigd: we wijzigen ook het model van de directive
                     * we gebruiken niet $scope.$watch op onze model-variabele, want dat zetten we het directive-model ook
                     * als men die programmatisch gewijzigd heeft, en volgt er een ng-change zonder user-wijziging
                     */
                    $scope.gewijzigdDoorUI = function () {
                        _updateViewValue();
                        //en test de vergelijkers
                        checkVergelijkers();
                    };

                    /**
                     * Interne code voor het update van de viewValue waarin wij het model zijn. Gebruikt bij wijziging in ui en bij
                     * wijzigign n.a.v. de vergelijkers
                     * @private
                     */
                    function _updateViewValue() {
                        if (!$scope.model) {
                            ngModel.$setViewValue(null);
                        }
                        else {
                            var mval = moment($scope.model);
                            ngModel.$setViewValue(('stringdate' in attrs) ? mval.format("YYYY-MM-DD") : mval);
                        }
                    };

                    $scope.checkKey = function (event) {

                        if (event.which && event.which === 9) {
                            //tab mag wel
                            return;
                        }
                        event.preventDefault();
                    };

                    ////validator
                    ngModel.$validators.daterange = function (modelvalue, viewvalue) {
                        //we controleren de modelvalue om te kijken of hij in de mindata/maxdate range zit
                        log.debug("Check daterange", modelvalue);
                        if (modelvalue && ($scope.lokaleOpties._minMoment || $scope.lokaleOpties._maxMoment)) {
                            var modelmoment = moment(modelvalue);
                            log.debug("Model", modelmoment.format());
                            log.debug("Min", $scope.lokaleOpties._minMoment && $scope.lokaleOpties._minMoment.format());
                            log.debug("Max", $scope.lokaleOpties._maxMoment && $scope.lokaleOpties._maxMoment.format());
                            if (
                                ($scope.lokaleOpties._minMoment && modelmoment.isBefore($scope.lokaleOpties._minMoment)) ||
                                ($scope.lokaleOpties._maxMoment && modelmoment.isAfter($scope.lokaleOpties._maxMoment))
                            ) {
                                log.debug('INVALID');
                                return false; //niet okee
                            }
                        }
                        return true; //als niet invalid
                    };

                    /**
                     * Werk onze constraints bij, gegeven de voor/na etc vergelijkers
                     */
                    function checkVergelijkers() {
                        //we moeten het altijd doorlopen, ook als ze null zijn, omdat we minDate / maxDate moeten resetten
                        //alleen als ze allemaal gelijk zijn, hoeven we niets te doen

                        var val = ngModel.$viewValue ? moment(ngModel.$viewValue) : null;

                        var newval = null;
                        var mom;
                        var mindates = [], maxdates = []; //beperkingen qua minimale datum en maximale datum
                        if ($scope.voor) {
                            mom = moment($scope.voor);

                            maxdates.push(mom.clone().subtract(1, 'day')); //eerder mag dus niet
                            if (val && !val.isBefore(mom)) {
                                //val moet voor $scope.voor:
                                newval = mom.clone().subtract(1, 'day'); //nu wel ervoor
                            }
                        }
                        if ($scope.voorOfGelijk) {
                            mom = moment($scope.voorOfGelijk);
                            maxdates.push(mom.clone());
                            if (val && !val.isSameOrBefore(mom)) {
                                newval = mom.clone();
                            }
                        }
                        if ($scope.na) {
                            mom = moment($scope.na);
                            mindates.push(mom.clone().add(1, 'day'));
                            if (val && !val.isAfter(mom)) {
                                //val moet voor $scope.voor:
                                newval = mom.clone().add(1, 'day'); //nu wel erna
                            }
                        }
                        if ($scope.naOfGelijk) {
                            mom = moment($scope.naOfGelijk);
                            mindates.push(mom.clone());
                            if (val && !val.isSameOrAfter(mom)) {
                                newval = mom.clone();
                            }
                        }
                        if ($scope.lokaleOpties._origMinMoment) {
                            mindates.push($scope.lokaleOpties._origMinMoment);
                        }
                        if (mindates.length) {
                            //de min wordt de grootste datum die we gevonden hebben
                            $scope.lokaleOpties._minMoment = moment.max(mindates);
                            $scope.lokaleOpties.minDate = $scope.lokaleOpties._minMoment.toDate();
                        }
                        else {
                            delete $scope.lokaleOpties._minMoment;
                            delete $scope.lokaleOpties.minDate;
                        }

                        if ($scope.lokaleOpties._origMaxMoment) {
                            maxdates.push($scope.lokaleOpties._origMaxMoment);
                        }
                        if (maxdates.length) {
                            //de max wordt de grootste datum die we gevonden hebben
                            $scope.lokaleOpties._maxMoment = moment.min(maxdates);
                            $scope.lokaleOpties.maxDate = $scope.lokaleOpties._maxMoment.toDate();
                        }
                        else {
                            delete $scope.lokaleOpties._maxMoment;
                            delete $scope.lokaleOpties.maxDate;
                        }

                        //ook nog een gewijzigde waarde?
                        if (newval) {
                            $scope.model = newval.toDate(); //want interne datepicker
                            _updateViewValue(); //niet buitenlangs
                        }

                        //en tenslotte de koppeling, dat moet dus ook een datemodel zijn
                        if (!$scope.koppel) {
                            $scope.koppel = ngModel.$viewValue; // $scope.model;
                        }
                    }
                }
            };
        }]).constant('sihwDatepickerTemplates', {
    //templates:
    main: `
    <div class="input-group datepicker-group noMargin">
    <input type="text"
           class="form-control sihwdatepickerinputveld"
           uib-datepicker-popup="{{dateFormat || $sihwng.dateFormat || 'dd-MM-yyyy'}}"
           datepicker-options="lokaleOpties"
           current-text="{{currentText || $sihwng.currentText || 'Vandaag'}}"
           clear-text="{{clearText || $sihwng.clearText || 'Legen'}}"
           close-text="{{closeText || $sihwng.closeText || 'Klaar'}}"
           datepicker-popup-template-url="sihwDatepickerPopuptemplate.html"
           ng-keypress="checkKey($event)"
           ng-keydown="checkKey($event)"
           ng-keyup="checkKey($event)"
           is-open="isopen"
           ng-model="model"
           placeholder = "{{attrs.placeholder}}"
           ng-blur="touched()"
           ng-change="gewijzigdDoorUI()"
            ng-disabled="attrs.disabled">
    <span class="input-group-btn">
        <button type="button"
                class="btn btn-default sihwdatepickerbutton"
                ng-click="openPopup()"
                ng-disabled="attrs.disabled"><i
                class="glyphicon glyphicon-calendar"></i></button>
    </span>
</div>
`,
    popup: `
<ul role="presentation"
    class="uib-datepicker-popup dropdown-menu uib-position-measure"
    dropdown-nested ng-if="isOpen" ng-keydown="keydown($event)"
    ng-click="$event.stopPropagation()">
    <li ng-transclude></li>
    <li ng-if="showButtonBar" class="uib-button-bar">
        <div class="row">
            <div class="col-xs-4 text-left">
                <button type="button"
                        class="btn btn-sm btn-info uib-datepicker-current"
                        ng-click="select('today', $event)"
                        ng-disabled="isDisabled('today')">{{ getText('current')
                    }}
                </button>
            </div>
            <div class="col-xs-4 text-center">
                <button type="button" class="btn btn-sm btn-danger uib-clear"
                        ng-click="select(null, $event)">{{ getText('clear') }}
                </button>
            </div>
            <div class="col-xs-4 text-right">
                <button type="button"
                        class="btn btn-sm btn-success pull-right uib-close"
                        ng-click="close($event)">{{ getText('close') }}
                </button>
            </div>
        </div>
    </li>
</ul>
 `
});
